import { BlogContentWideDescription } from './BlogContentWideDescription';
import { IElement } from '../../../models/Element';
import { ElementWrapper } from '../../../components/ElementWrapper';
import { TextAreaEdit } from '../../../components/TextAreaEdit';
import { TextEditor } from '../../../../../components/TextEditor';
import { HeaderSelectWrapper } from '../../../components/HeaderSelectWrapper';
import { ElementHeaderType } from '../../utils';

type BlogContentWideDescriptionFCProps = {
  index: number;
  data: BlogContentWideDescription;
  updateData: (body: IElement, index: number) => void;
};

export const BlogContentWideDescriptionFC = ({
  index,
  data,
  updateData,
}: BlogContentWideDescriptionFCProps) => {
  const update = (fieldsToUpdate: Partial<BlogContentWideDescription>) => {
    const updatedData = { ...data, ...fieldsToUpdate };
    updateData(updatedData, index);
  };

  return (
    <ElementWrapper elementIndex={index}>
      <div className="blog-content-wide-description body-my-8">
        <div className="blog-content">
          {/* begin::Title */}
          <HeaderSelectWrapper
            name={`title_type`}
            value={data.title_type ?? ElementHeaderType.H2}
            setValue={update}
          >
            <TextAreaEdit
              name="title"
              className={`blog-content__title`}
              value={data.title}
              setValue={update}
            />
          </HeaderSelectWrapper>
          {/* end::Title */}

          <TextEditor
            content={data.content}
            updateContent={(content) => update({ content })}
          />
        </div>
      </div>
    </ElementWrapper>
  );
};
